export default "__VITE_ASSET__PNKUVXbl__"